import { inject } from '@angular/core';
import { IApiResponse } from '@web/shared-types';
import { Observable } from 'rxjs';
import { RestCallBuilder } from '../../../../builder/rest/rest-call.builder';
import { AppConfigService } from '../../../app-config.service';
import { IGetGateway, ISaveGateway } from '../../gateways';
import { BankDataId, ICreateSubscriptionPreferences } from '@web/dtos';

export class SubscriptionPaymentPreferenceGateway
  implements
    IGetGateway<void, IApiResponse<BankDataId>>,
    ISaveGateway<ICreateSubscriptionPreferences, IApiResponse<string>>
{
  private readonly configService: AppConfigService = inject(AppConfigService);

  private readonly restCallBuilder: RestCallBuilder<string, BankDataId> =
    new RestCallBuilder<string, BankDataId>('' as BankDataId);
  private readonly saveRstCallBuilder: RestCallBuilder<
    ICreateSubscriptionPreferences,
    string
  > = new RestCallBuilder<ICreateSubscriptionPreferences, string>('');

  get(): Observable<IApiResponse<BankDataId>> {
    return this.restCallBuilder
      .getExternal(
        `${this.configService.get().general.userServiceUrl}/user/subscription-payment-preference`
      )
      .handleMessages()
      .build();
  }

  save(
    query: ICreateSubscriptionPreferences
  ): Observable<IApiResponse<string>> {
    return this.saveRstCallBuilder
      .postExternal(
        `${this.configService.get().general.userServiceUrl}/user/subscription-payment-preference`,
        query
      )
      .handleMessages()
      .build();
  }
}
